import { css } from '@emotion/react';
import { darken } from 'polished';
import Mixin from '../../../util/mixin';
import { GradientBg } from './_gradients.mixin';


export class AlertVariant extends Mixin {
  style({$}, [background, border, color]) {
    return css`
      color: ${color};
      ${new GradientBg(background).include($)};
      border-color: ${border};

      hr {
        border-top-color: ${darken(0.05, border)};
      }

      .alert-link {
        color: ${darken(0.10, color)};
      }
    `;
  }
}